import { useEffect, useState } from "react";
import type { FirstSyncPreview } from "@/lib/merge";
import { subscribeSync, syncSnapshot, type SyncStatus, type SyncUser } from "@/lib/sync";

/**
 * Who is signed in and what sync is doing. A thin subscription over the
 * module-level store in `lib/sync.ts` — the sync loop itself is started once
 * from `main.tsx`, not from an effect, so mounting this hook never kicks
 * anything off.
 */
export function useAuth(): {
  user: SyncUser | null;
  status: SyncStatus;
  error: string | null;
  pending: FirstSyncPreview | null;
} {
  const [, force] = useState(0);
  useEffect(() => subscribeSync(() => force((n) => n + 1)), []);
  return syncSnapshot();
}
